import Container from '@/components/Container';
import Divider from '@/components/Divider';
import SubContainer from '@/components/Container/SubContainer';

import { Header } from './components/header';
import DailyCards from './components/daily-cards';
import Latests from './components/latests-resources';
import AwarenessCalendarResources from './components/awareness-calendar-resources';
import { useHome } from './hooks/useHome';
import { Suspense } from 'react';
import { Loading } from './components/loading';
import { HomePage as HomePageType } from '@edwin-group/cj-graphql';
import { Programmes } from './components/programmes';
import { Missions } from './components/missions';

const HomePageComponent = () => {
  const { homePage, hasResourceHubAccess, hasMissionAccess } = useHome();

  return (
    <Container className="!gap-0 md:!gap-0">
      <SubContainer>
        <div className="mt-sh-60 flex flex-col gap-[5px]">
          <Header page={homePage?.homePage as HomePageType} />
        </div>
        <Divider />
        <div className="mb-sh-10 md:flex md:gap-4">
          <DailyCards page={homePage?.homePage as HomePageType} />
        </div>
        {hasMissionAccess && (
          <>
            <Divider />
            <Programmes page={homePage?.homePage as HomePageType} />
            <Divider />
            <Missions page={homePage?.homePage as HomePageType} />
          </>
        )}
        {hasResourceHubAccess && (
          <>
            <Divider />
            <Latests />
          </>
        )}
        <div className=" last-divider-hidden mt-10">
          <AwarenessCalendarResources />
        </div>
      </SubContainer>
    </Container>
  );
};

const HomePage = () => {
  return (
    <Suspense fallback={<Loading />}>
      <HomePageComponent />
    </Suspense>
  );
};

export default HomePage;
